import React from "react";
import { Grid, Typography, Paper, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useClientLayout } from "../../Components/Context/CandidateLayoutContext";

const ClientProfilePortal = () => {
  const navigate = useNavigate();
  const { clientData } = useClientLayout();

  return (
    <Paper sx={{ p: { xs: 2, sm: 3, md: 5 }, m: "auto", minHeight: "100%" }}>
      <Grid container justifyContent="flex-start" sx={{ mb: 3 }}>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#B0BEC5"
            onClick={() => navigate("/")}
          >
            Back
          </CommonButton>
        </Grid>
      </Grid>

      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        mb={2}
      >
       Profile
      </Typography>

      {/* Basic Information Section */}
      <Box
        sx={{
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
          >
            Basic Information
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {[
            { label: "Name", value: clientData?.CD_Name },
            { label: "Email", value: clientData?.CD_Email },
            { label: "Contact Number", value: clientData?.CD_Phone },
            { label: "Address", value: clientData?.CD_Address },
            { label: "Country", value: clientData?.CD_CountryName },
            { label: "Company Type", value: clientData?.CD_CompanyTypeName },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "18px",
                    mb: 0.5,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {item.value || "—"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default ClientProfilePortal;
